// extracted by mini-css-extract-plugin
export default {"suggestionBox":"SuggestionBox_suggestionBox__oOw+j","suggestionItem":"SuggestionBox_suggestionItem__lZ-Lp","whiteLoader":"SuggestionBox_whiteLoader__U7DYr"};